// List of search results

import React from "react";
import PropTypes from "prop-types";
import {
  connectHits,
  connectStateResults,
  Pagination
} from "react-instantsearch-dom";

import APlusDialog from "components/shared/dialogs/APlusDialog";
import Hit from "components/search/base/Hit";
import logo from "images/logos/small-logo-and-wordmark-a-plus.svg";
import number from "helpers/number";
import NoResults from "components/search/base/NoResults";

const propTypes = {
  aPlusPromoUrl: PropTypes.string.isRequired,
  hits: PropTypes.array,
  isAPlus: PropTypes.bool,
  promoInfo: PropTypes.shape({
    characterCount: PropTypes.number,
    litDeviceCount: PropTypes.number,
    quizCount: PropTypes.number,
    quoteCount: PropTypes.number,
    symbolCount: PropTypes.number,
    themeCount: PropTypes.number
  }).isRequired,
  userSignedIn: PropTypes.bool
};

const defaultProps = {
  hits: [],
  isAPlus: false,
  userSignedIn: false
};

const Paginate = connectStateResults(({ searchResults }) => {
  if (searchResults && searchResults.nbHits <= 20) return null;

  return (
    <div id="pagination" className="lc-pagination">
      <Pagination showLast />
    </div>
  );
});

const PromoContent = connectStateResults(
  ({ promoInfo, searchResults, searchState }) => {
    const relatedText =
      (searchState.query || "").length > 0
        ? `related to ${searchState.query}`
        : "related to your search";
    const resultData = searchResults.disjunctiveFacets[0].data;
    return (
      <div>
        <div>
          Unlock <strong>Advanced Search</strong>. Get the power to{" "}
          <strong>refine</strong> your search and find <strong>related</strong>{" "}
          themes, symbols, characters, or quotes:
        </div>
        <ul>
          <li className="theme">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.themeCount
            )} themes`}</strong>{" "}
            ({number.commaSeparateNumber(resultData["Lit Guide > Theme"] || 0)}{" "}
            {relatedText})
          </li>
          <li className="symbol">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.symbolCount
            )} symbols`}</strong>{" "}
            ({number.commaSeparateNumber(resultData["Lit Guide > Symbol"] || 0)}{" "}
            {relatedText})
          </li>
          <li className="character">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.characterCount
            )} characters`}</strong>{" "}
            (
            {number.commaSeparateNumber(
              resultData["Lit Guide > Character"] || 0
            )}{" "}
            {relatedText})
          </li>
          <li className="quotes">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.quoteCount
            )} quotes`}</strong>{" "}
            ({number.commaSeparateNumber(resultData["Lit Guide > Quotes"] || 0)}{" "}
            {relatedText})
          </li>
          <li className="quizzes">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.quizCount
            )} quizzes`}</strong>{" "}
            (
            {number.commaSeparateNumber(resultData["Lit Guide > Quizzes"] || 0)}{" "}
            {relatedText})
          </li>
          <li className="lit-devices">
            <strong>{`${number.commaSeparateNumber(
              promoInfo.litDeviceCount
            )} literary devices`}</strong>{" "}
            (
            {number.commaSeparateNumber(
              resultData["Lit Guide > Lit Device"] || 0
            )}{" "}
            {relatedText})
          </li>
        </ul>
      </div>
    );
  }
);

function Hits(props) {
  if (props.hits.length === 0) {
    return (
      <NoResults
        userSignedIn={props.userSignedIn}
        showRequestContentAfterDelay={props.showRequestContentAfterDelay}
      />
    );
  }

  // Set so only 1 promo can be visible at a time
  let shownPromo = false;
  return (
    <div id="hits">
      {props.hits.map((hit) => {
        if (
          !props.isAPlus &&
          !shownPromo &&
          ["Lit Guide", "Poetry Guide", "Shakescleare", "Lit Term"].indexOf(
            hit.category.split(" > ")[1]
          ) < 0
        ) {
          shownPromo = true;
          return (
            <div key={hit.objectID} className="hits__a-plus-container">
              <div className="hits__a-plus-dialog">
                <APlusDialog
                  amplitudeKey="advancedSearchCentralColumn"
                  href={props.aPlusPromoUrl}
                  logoSrc={logo}
                  isFreeTier={props.userSignedIn}
                >
                  <PromoContent promoInfo={props.promoInfo} />
                </APlusDialog>
              </div>
              <Hit hit={hit} isAPlus={props.isAPlus} />
            </div>
          );
        }

        return <Hit key={hit.objectID} hit={hit} isAPlus={props.isAPlus} />;
      })}
      <Paginate />
    </div>
  );
}

Hits.propTypes = propTypes;
Hits.defaultProps = defaultProps;

export default connectHits(Hits);
